const Top = () => {
    const subdomain = window.location.hostname.split(".")[0];
    const handleClick = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };
    return (
        <div className="flex flex-col items-center gap-0.5 cursor-pointer" onClick={handleClick}>
            <div
                className={`w-[2px] h-[15px] ${subdomain === "air" ? "bg-air" : subdomain === "morning" ? "bg-morning" : subdomain === "quick" ? "bg-quick" : "bg-express"}`}
            />
            <p
                className={`text-[15px] ${subdomain === "air" ? "text-air" : subdomain === "morning" ? "text-morning" : subdomain === "quick" ? "text-quick" : "text-express"}`}
            >
                TOP
            </p>
        </div>
    );
};

export default Top;
